export default __webpack_public_path__ + "static/media/chicken.da77cd3c.jpg";